// extracted by mini-css-extract-plugin
export var container = "PriceChangesReport-module--container--5MYKd";
export var content = "PriceChangesReport-module--content--bPe9i";
export var label = "PriceChangesReport-module--label--FcIh3";